var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 5.66667V4.58333L19.5 6.75L16.25 4.58333V5.66667L19.5 7.83333L22.75 5.66667ZM23.8333 0.25H2.16667C0.975 0.25 0 1.225 0 2.41667V17.5833C0 18.775 0.975 19.75 2.16667 19.75H23.8333C25.025 19.75 25.9892 18.775 25.9892 17.5833L26 2.41667C26 1.225 25.025 0.25 23.8333 0.25ZM8.66667 3.5C10.465 3.5 11.9167 4.95167 11.9167 6.75C11.9167 8.54833 10.465 10 8.66667 10C6.86833 10 5.41667 8.54833 5.41667 6.75C5.41667 4.95167 6.86833 3.5 8.66667 3.5ZM15.1667 16.5H2.16667V15.4167C2.16667 13.25 6.5 12.0583 8.66667 12.0583C10.8333 12.0583 15.1667 13.25 15.1667 15.4167V16.5ZM23.8333 10H15.1667V3.5H23.8333V10Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d51a84ea289fcc4972f51b6a827db91c.svg";
export { ForwardRef as ReactComponent };